import { OnInit } from "@angular/core";
import { addDays } from '@progress/kendo-date-math';

export class ReportPageBase implements OnInit {

	public range = { start: new Date(), end: new Date() };
	public dataGenerating = false;

	constructor() {

	}

	ngOnInit(): void {

	}

	protected generateReportByDateRange(getReport: (startDate: string, endDate: string) => void, range: any = null, switchDataGenerationFlag: boolean = true) {

		let rangeVar = this.range;

		if (range != null) {
			rangeVar = range;
		}

		if (switchDataGenerationFlag) {
			this.dataGenerating = true;
		}

		let startDate, endDate;
		if (rangeVar.start) {
			rangeVar.start.setHours(0, 0, 0, 0);
			startDate = this.getDate(rangeVar.start);
		}

		if (rangeVar.end) {
			rangeVar.end.setHours(0, 0, 0, 0);

			let dateEnd = new Date(rangeVar.end);
			dateEnd = addDays(dateEnd, 1);

			endDate = this.getDate(dateEnd);
		}

		getReport(startDate, endDate);
	}

	protected getDate(date) {
		return new Date(date).toJSON();
	}

}
